import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const pct = (p) => `${Math.round(p * 100)}%`;
const Logo = ({ src }) => (src ? <img src={src} alt="" className="w-5 h-5 rounded-full bg-white/90 p-[1px] object-contain shrink-0" /> : null);

// College football: win/loss pick only (moneyline-implied, vig removed).
export default function CfbGameCard({ g, badge }) {
  const [open, setOpen] = useState(false);
  const pk = g.pick;
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/70" data-testid={`cfb-game-${g.event_id}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 p-3 text-left" data-testid={`cfb-game-toggle-${g.event_id}`}>
        {g.teams.map((t) => <Logo key={t.id} src={t.logo} />)}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-white truncate">{g.teams.map((t) => `${t.rank ? `#${t.rank} ` : ''}${t.abbr}`).join(' @ ')}{badge}</p>
          <p className="text-[11px] text-zinc-500">{new Date(g.date).toLocaleString([], { weekday: 'short', hour: 'numeric', minute: '2-digit' })}{g.spread ? ` · ${g.spread}` : ''}</p>
        </div>
        {pk && <span className="text-[11px] font-bold text-emerald-300 shrink-0">{pk.abbr} {pct(pk.prob)}</span>}
        <ChevronDown className={`w-5 h-5 text-zinc-500 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2" data-testid={`cfb-game-detail-${g.event_id}`}>
          {g.teams.map((t) => (
            <p key={t.id} className="text-xs text-zinc-300"><span className="font-semibold text-white">{t.name}</span> {t.record ? `(${t.record})` : ''}{t.ml ? ` · ML ${t.ml}` : ''}</p>
          ))}
          {pk ? (
            <div className="rounded-lg border border-emerald-500/40 bg-emerald-950/20 p-2">
              <p className="text-sm font-bold text-emerald-300">Pick: {pk.team} to win · {pct(pk.prob)}</p>
              <p className="text-[11px] text-zinc-400">{pk.reason}</p>
              {pk.why && (
                <ul className="mt-1 space-y-0.5" data-testid={`cfb-why-${g.event_id}`}>
                  {pk.why.map((l) => <li key={l} className="text-[11px] text-zinc-300">• {l}</li>)}
                </ul>
              )}
              {pk.prob < 0.6 && <p className="text-[11px] text-amber-300">Close game — not a safe leg.</p>}
            </div>
          ) : <p className="text-[11px] text-zinc-500">No betting line posted yet.</p>}
        </div>
      )}
    </div>
  );
}
